import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map, of, switchMap, throwError } from 'rxjs';
import { defaultAuthConfiguration, logoutWithReturnUrl } from '@touch4it/ng-swp/auth';
import { CrmConfigService } from '@touch4it/ng-swp/core';

import { UsersApiService } from '~/api/users/users-api.service';
import { ProfilesApiService } from '~/api/profiles/profiles-api.service';

export const workspaceGuard: CanMatchFn = (_, segments) => {
  const userService = inject(UsersApiService);
  const profilesService = inject(ProfilesApiService);
  const router = inject(Router);
  const authConfig = inject(CrmConfigService).mergeConfig(defaultAuthConfiguration, 'modules.auth');

  const workspaceSegment = segments[0].path;

  return userService.user$.pipe(
    switchMap((user) => {
      if (user.roles.admin) {
        return profilesService.listAllWorkspaces().pipe(
          map((c) => {
            const found = c.find(({ namespace }) => namespace === workspaceSegment);
            return found ?? c[0];
          }),
        );
      }

      if (!user.workspaceId) {
        return throwError(() => new Error(`no workspace Id for user '${user._id}'`));
      }

      return profilesService.getWorkspace(user.workspaceId);
    }),
    map(({ namespace }) => {
      if (namespace !== workspaceSegment) {
        return false;
      }

      profilesService.setCurrentWorkspace(namespace);
      return true;
    }),
    catchError(() => {
      logoutWithReturnUrl({ userService, router, authConfig });
      return of(false);
    }),
  );
};
